import { pick } from 'lodash';
import { createStoryBrandKitSnapshot } from 'common/brand-kit/projection';
import type { StoredBrandKit } from 'common/brand-kit/types';
import type { StoryMediaPlatform, StorySettingsType } from 'types/story';

export const STORY_BRAND_SETTINGS = ['brandKitId', 'design', 'brandContext', 'designModes'] as const;

export function getStoryCreationBrandSettings({
	enabled,
	kits,
	brandKitId = null,
	templateSettings,
	defaultPlatform,
}: {
	enabled: boolean;
	kits?: StoredBrandKit[];
	brandKitId?: string | null;
	templateSettings?: StorySettingsType;
	defaultPlatform?: StoryMediaPlatform;
}): Pick<StorySettingsType, (typeof STORY_BRAND_SETTINGS)[number]> {
	if (enabled) return createStoryBrandKitSnapshot(kits, brandKitId, templateSettings, defaultPlatform);
	return structuredClone(pick(templateSettings, STORY_BRAND_SETTINGS));
}
